import { render } from "./Audio.vue?vue&type=template&id=082d5838&scoped=true"
import script from "./Audio.vue?vue&type=script&setup=true&lang=js"
export * from "./Audio.vue?vue&type=script&setup=true&lang=js"

import "./Audio.vue?vue&type=style&index=0&id=082d5838&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082d5838"],['__file',"resources/js/components/whatsapp-managment/includes/ReplyMessages/ReceivedReply/Audio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "082d5838"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('082d5838', __exports__)) {
    console.log('reload')
    api.reload('082d5838', __exports__)
  }
  
  module.hot.accept("./Audio.vue?vue&type=template&id=082d5838&scoped=true", () => {
    console.log('re-render')
    api.rerender('082d5838', render)
  })

}


export default __exports__